import styled from 'styled-components';

export const ItemPlaceholder = styled.div<{isTechContemporary?: boolean}>`
  background: ${({ isTechContemporary }) => isTechContemporary ?
  `
  linear-gradient(180deg, rgba(180,180,180,1) 0%, rgba(228,225,225,1) 0%, rgba(245,245,245,1) 47%, rgba(249,249,249,1) 73%);  `
   : `
  linear-gradient(
    180deg,
    #292929 0%,
    rgba(41, 41, 41, 0.139535) 59.68%,
    rgba(41, 41, 41, 0) 69.35%);`}; 
  border-radius: 5px;
  min-height: 250px;
`;
